@if (loading() && automations().length === 0) {
  <glxy-loading-spinner></glxy-loading-spinner>
} @else {
  @if (automations().length === 0) {
    <div class="empty-state-inline">
      <mat-icon>offline_bolt</mat-icon>
      <span>{{ 'AI_ASSISTANT.SETTINGS.EMPTY_STATE.NO_AUTOMATIONS' | translate }}</span>
    </div>
  } @else {
    <mat-list>
      @for (automation of automations(); track automation.id) {
        <mat-list-item lines="3" class="list-item">
          <mat-icon class="icon" matListItemIcon>offline_bolt</mat-icon>
          <div matListItemLine class="title">
            <a class="title-link"
               [routerLink]="['../../../../', 'automations', 'automation', automation.id]">{{ automation.name }}</a>
          </div>
          @if (automation.description) {
            <div class="preview" matListItemLine>
              <span>{{ automation.description }}</span>
            </div>
          }
          <span
            class="status-text">{{ 'AI_ASSISTANT.SETTINGS.AUTOMATIONS_LAST_UPDATED' | translate: { updatedAt: automation.updated | date: 'MMM dd, yyyy' } }}</span>
        </mat-list-item>
        <mat-divider class="break-out-mat-card-content"></mat-divider>
      }
    </mat-list>
    @if (hasMore() && !loading()) {
      <a (click)="loadMoreAutomations()"
         class="view-more">{{ 'AI_ASSISTANT.SETTINGS.CHANNELS.VIEW_MORE' | translate }}</a>
    }

    @if (loading()) {
      <glxy-loading-spinner></glxy-loading-spinner>
    }
  }
}
